<sl-title title="{{ title }}" hidePendo="true"></sl-title>
<div class="landing-content">
	<div class="center-body">
		<div class="linq-box landing-image-logo"></div>
		<div class="right-content">
			<form (ngSubmit)="onSubmit()" #unitForm="ngForm">
				<div class="content-header">
					Sign In
				</div>
				<div class="content-body">
					<mat-form-field>
						<mat-label id="unitId">Unit ID</mat-label>
						<input type="text" aria-labelledby="unitId" name="UnitId" #UnitId="ngModel" matInput [(ngModel)]="unitId" requiredNoWhitespace
							maxlength="20" />
						<mat-error *ngIf="UnitId.errors?.required">Unit ID is required</mat-error>
					</mat-form-field>
				</div>
				<div class="content-footer">
					<button type="submit" mat-raised-button color="primary" class="col-xs-12" [disabled]="unitForm.invalid">Login</button>
				</div>
			</form>
		</div>
	</div>
</div>
<sb-copyright></sb-copyright>
